export const FAILURE_TYPE_DEFINITIONS = [
    {
        label: "Hallucination",
        description: "Provides information that is made up or not supported by any source."
    },
    {
        label: "Incorrect answer",
        description: "Provides an answer that is not fabricated but does not correctly address the question or contains wrong information."
    },
    {
        label: "Incomplete answer",
        description: "Provides a partially correct answer, but important details are missing."
    },
    {
        label: "No answer",
        description: "Does not provide an answer."
    },
    {
        label: "Question issue",
        description: "The question is unclear, too broad, or ambiguous and cannot be answered reliably."
    },
    {
        label: "Technical issue",
        description: "The failure is caused by a system or technical problem (e.g., UI issues, unsupported functionality)."
    },
    {
        label: "Policy issue",
        description: "Response is blocked due to incorrect policy constraints (e.g. PHI detection)."
    },
    {
        label: "Source issue",
        description: "Sources are missing, incorrect, unavailable, or not properly pulled to support the answer."
    },
    {
        label: "Other",
        description: "Issues that do not fit any of the categories above."
    }
] as const;

export const FAILURE_TYPES = FAILURE_TYPE_DEFINITIONS.map(({ label }) => label);
